// ----------------------------------------------------------------------------
// Component: Image Text 50/50
// ----------------------------------------------------------------------------

import './_image-text-50-50.scss';